import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-id-resolver',
  templateUrl: './id-resolver.component.html',
  styleUrls: ['./id-resolver.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class IdResolverComponent implements OnInit {
  isLoading = true;
  notFound = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    const uniqueId = this.route.snapshot.paramMap.get('uniqueId') ?? '';
    this.apiService.resolveUniqueId(uniqueId).subscribe({
      next: (result) => {
        if (result.redirectUrl) {
          window.location.href = result.redirectUrl;
        } else {
          this.router.navigate(['/'], {
            queryParams: { entityId: result.entityId, entityType: result.entityType }
          });
        }
      },
      error: (err) => {
        this.isLoading = false;
        if (err.status === 404) {
          this.notFound = true;
        } else {
          this.errorMessage = 'אירעה שגיאה בטעינת המזהה';
        }
      }
    });
  }
}
